import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule, PipesModule } from '@tdwb/core';

import { LearnDurationComponent } from './learn-duration.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
  declarations: [
    LearnDurationComponent
  ],
  exports: [
    LearnDurationComponent
  ]
})
export class LearnDurationModule {
}
